import type { BackendClient } from '../../client'
import { MockAIService } from './ai.mock'
import { MockRagService } from './rag.mock'
import { MockPromptStore } from './prompts.mock'
import { MockSystemPromptStore } from './system-prompts.mock'
import { MockSpeechService } from './speech.mock'
import { MockSkillStore } from './skills.mock'

export interface MockSeed {
  /** Base latency in ms for simulated calls (default 20). */
  latencyMs?: number
}

/** In-memory backend seeded with the data from the SafeAI Plus mockups. */
export function createMockBackendClient(seed: MockSeed = {}): BackendClient {
  const latency = seed.latencyMs ?? 20
  return {
    ai: new MockAIService(latency),
    rag: new MockRagService(latency),
    prompts: new MockPromptStore(latency),
    systemPrompts: new MockSystemPromptStore(latency),
    speech: new MockSpeechService(),
    skills: new MockSkillStore(latency),
  }
}

// Seed data, shared with the delivery server's prompt store.
export { PROMPT_SEED } from './prompts.mock'
export { SYSTEM_PROMPT_SEED } from './system-prompts.mock'
